// export with module.exports to keep compatibility with nodejs build scripts @etiurin
module.exports = {
  features: {
    overwriteCustomStyles: 'overwriteCustomStyles',
    surveyCreationWizard: 'surveyCreationWizard',
    questionBank: 'questionBank',
  },
};
